export default "__VITE_ASSET__Dd1h6qHj__"